import { useRef } from "react";
import React from "react";
import { Button, Table, Typography, Divider } from "antd";
import RollbackOutlined from "@ant-design/icons/RollbackOutlined";
import CheckOutlined from "@ant-design/icons/CheckOutlined";
import ModalBase from "../lib/common/ModalBase";
import { useModal } from "../lib/modal/ModalContext";

interface DataCompareModalProps {
  before: any[] | null;
  after: any[] | null;
  history?: any[] | null; 
  onApplyData: () => void;
}

const getTableColumns = (rows: any[] | null | undefined) => {
  if (!Array.isArray(rows) || rows.length === 0 || rows[0] == null) {
    return [];
  }
  return Object.keys(rows[0])
    .filter((k) => k !== "key")
    .map((key) => ({
      title: key,
      dataIndex: key,
      key,
      render: (text: any) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: 180,
            cursor: "pointer",
          }}
          title={text}
        >
          {typeof text === "string" || typeof text === "number" ? String(text) : ""}
        </div>
      ),
    }));
};

const getTableData = (rows: any[] | null | undefined) => {
  if (!Array.isArray(rows)) return [];
  return rows.map((row, idx) => ({
    key: idx,
    ...row,
  }));
};

const DataCompareModal: React.FC<DataCompareModalProps> = ({
  before,
  after,
  history = null,
  onApplyData,
}) => {
  const { isVisible, hideModal, modalContent, showModal } = useModal();

  const beforeRef = useRef<HTMLDivElement>(null);
  const afterRef = useRef<HTMLDivElement>(null);

  const syncScroll = (source: "before" | "after") => {
    const beforeEl = beforeRef.current;
    const afterEl = afterRef.current;

    if (!beforeEl || !afterEl) return;

    if (source === "before") {
      afterEl.scrollTop = beforeEl.scrollTop;
      afterEl.scrollLeft = beforeEl.scrollLeft;
    } else {
      beforeEl.scrollTop = afterEl.scrollTop;
      beforeEl.scrollLeft = afterEl.scrollLeft;
    }
  };

  return (
    <ModalBase>
      <div
        className="w-[90vw] h-[90vh] relative flex flex-col bg-white rounded-lg box-border overflow-auto"
      >
        <div className="p-10">
          <div className="flex flex-col justify-between gap-10">
            <Typography.Title level={1} className="text-4xl">
              데이터 변경을 최종 확인해 주세요
            </Typography.Title>
            <div className="flex flex-col justify-start gap-5">
              {Array.isArray(before) && before.length > 0 && (
                <div
                  className="overflow-scroll"
                  ref={beforeRef}
                  onScroll={() => syncScroll("before")}
                  style={{ maxHeight: 300 }}
                >
                  <Typography.Title level={5}>데이터 변경전</Typography.Title>
                  <Table
                    columns={getTableColumns(before)}
                    dataSource={getTableData(before)}
                    bordered
                    pagination={false}
                    size="small"
                  />
                </div>
              )}
              {Array.isArray(before) && before.length > 0 && Array.isArray(after) && after.length > 0 && (
                <Divider style={{ margin: "24px 0" }}>
                  <span style={{ fontWeight: "bold", color: "#888" }}>
                    ↓ 변경 후 데이터 ↓
                  </span>
                </Divider>
              )}
              {Array.isArray(after) && after.length > 0 && (
                <div
                  className="overflow-scroll"
                  ref={afterRef}
                  onScroll={() => syncScroll("after")}
                  style={{ maxHeight: 300 }}
                >
                  <Typography.Title level={5}>데이터 변경후</Typography.Title>
                  <Table
                    columns={getTableColumns(after)}
                    dataSource={getTableData(after)}
                    bordered
                    pagination={false}
                    size="small"
                  />
                </div>
              )}
              {Array.isArray(history) && history.length > 0 && (
                <div
                  className="overflow-scroll mt-4"
                  style={{ maxHeight: 300 }}
                >
                  <Typography.Title level={5}>History</Typography.Title>
                  <Table
                    columns={getTableColumns(history)}
                    dataSource={getTableData(history)}
                    bordered
                    pagination={false}
                    size="small"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="w-full flex justify-center gap-2">
          <Button
            type="primary"
            danger
            style={{ fontWeight: "bold" }}
            icon={<RollbackOutlined />}
            onClick={()=>{
              hideModal();
              alert("작업이 취소 되었습니다");
              window.location.reload();
            }}
          >
            롤백
          </Button>
          <Button
            icon={<CheckOutlined />}
            onClick={() => {
              onApplyData();
              hideModal();
            }}
          >
            적용하기
          </Button>
        </div>
      </div>
    </ModalBase>
  );
};

export default DataCompareModal;
